import { deepmerge } from '@mui/utils'
import { responsiveFontSizes as addResponsiveFonts, Theme } from '@mui/material'
import { baseThemeOptions } from './mui-option/base-theme-options'
import { defaultPalette } from './mui-option/palette/palette'
import { overrideComponents } from './mui-option/component/override-components'
import { overrideTypography } from './mui-option/typography/override-typography'
import { CssUnit, handleCssUnit as sourceHandleCssUnit } from '../model/CssUnit'

function getBaseThemeOptions() {
  return deepmerge(baseThemeOptions, { palette: defaultPalette })
}

function passCssUnitHelper(theme: Theme) {
  return deepmerge(theme, {
    handleCssUnit: sourceHandleCssUnit,
  })
}

function upgradeTheme(theme: Theme) {
  const { handleCssUnit, palette } = theme

  return deepmerge(theme, {
    border: `0.115em solid ${palette.grey['50']}`,
    getSquareSize: (size: CssUnit) => ({
      width: handleCssUnit(size),
      height: handleCssUnit(size),
    }),
  })
}

export function getThemeOptions(): Theme {
  let theme = getBaseThemeOptions()
  theme = passCssUnitHelper(theme)
  theme = upgradeTheme(theme)
  theme = overrideComponents(theme)
  theme = overrideTypography(theme)
  
  return addResponsiveFonts(theme)
}
